'use strict';

class CustomPopup {
  constructor() {
    document.addEventListener('DOMContentLoaded', function() {
      // Check if the modal has already been opened
      var modal = document.querySelector('#custom-pop-up');
      if(modal){
        var secondsToAppear = modal.getAttribute('data-seconds');
        var popupId = modal.getAttribute('data-id');
        var modalOpened = modal.classList.contains('modal-opened'),
            modalCTA = document.getElementById("pop-up-cta");
        const closeIcon = document.getElementById("custom-popup-close-button");
        if(modalOpened){
          document.body.classList.add('custom-pop-up');
        }
        // Check if the cookie is set
        var cookieValue = getCookie('Popup_' + popupId);
        
        // Trigger popup after certain time
        setTimeout(function() {
          if (!modalOpened && cookieValue !== '1') {
            openModal(modal, popupId, modalCTA, closeIcon);
          }
        }, secondsToAppear * 1000);
        
        // Add exit intent listener if modal is not opened yet
        if (!modalOpened && cookieValue !== '1') {
          document.querySelector('body').addEventListener("mouseleave", (event) => {
            openModal(modal, popupId, modalCTA, closeIcon);
          }, { once: true });
        }
      }

      function openModal(modal, popupId, modalCTA, closeIcon) {
        var modalInstance = new Foundation.Reveal(jQuery(modal));
        modalInstance.open();
        // Add the 'modal-opened' class to mark the modal as opened
        modal.classList.add('modal-opened');
        function handleModalAction() {
          setCookie('Popup_' + popupId, '1', 7); // Set the cookie for 7 days
          UPT_GA_Events.triggerEvent('Popup', 'Click', 'Register', '');
        }
        if(modalCTA) {
          modalCTA.onclick = function() {
            handleModalAction();
          };
        }
        if (closeIcon) {
          closeIcon.onclick = function() {
            handleModalAction();
          };
        }
        const modalArea = document.getElementById("custom-pop-up");
        const modalAreaParentElement = modalArea.closest('.reveal-overlay');
        if(modalAreaParentElement) {
          modalAreaParentElement.onclick = function() {
            handleModalAction();
          };
        }
      }

      function setCookie(cName, cValue, expDays) {
        const date = new Date();
        date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        const cookieString = cName + "=" + cValue + "; " + expires + "; path=/";
        document.cookie = cookieString;
      }

      function getCookie(cName) {
        var name = cName + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var cookieArray = decodedCookie.split(';');
        
        for (var i = 0; i < cookieArray.length; i++) {
          var cookie = cookieArray[i].trim();
          if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length);
          }
        }
        
        return "";
      }
    });
  }
}

new CustomPopup();
